// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commutably {
  --file-input-area-color: var(--color-grey-2);
  --file-input-area-margin: 0 0 1em 0;
}
`, "",{"version":3,"sources":["webpack://./src/theme/components/FileInputArea.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;EAC5C,mCAAmC;AACrC","sourcesContent":[".commutably {\n  --file-input-area-color: var(--color-grey-2);\n  --file-input-area-margin: 0 0 1em 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
